<template>
    <v-app id="inspire">
        <v-layout row justify-center>
            <v-dialog v-model="onShow" persistent max-width="40%">
                <v-card>
                    <v-card-title>
                        <span class="subheading">MARS - Assign roles to user: {{ user.userName }}</span>
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-layout wrap>
                        <v-container id="scroll-target" style="max-height: 70%" class="scroll-y">
                            <br/>

                            <v-list-tile v-for="userRole in userRoles" v-bind:key="userRole.role.roleId">
                                <v-list-tile-content>
                                    <v-checkbox :id="'user_role_assignment_checkbox_' + userRoles.indexOf(userRole)"
                                                :input-value="userRole.roleSelected"
                                                v-model="userRole.roleSelected"
                                                :label="userRole.role.name"
                                                @click.native="onRoleSelected(userRole)"
                                                multiple="true" :disabled="isRoleAssignmentDisabled(userRole)">
                                    </v-checkbox>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-container>
                    </v-layout>

                    <v-alert :value="error" type="error" transition="scale-transition">
                        {{ errorMessage }}
                    </v-alert>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="text-none" color="green" small dark @click="onSaveSelectedRoles"
                               :disabled="!editMode">
                            Save
                        </v-btn>
                        <v-btn class="text-none" small @click="close">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-app>
</template>

<script>

    import userroleinterface from "../../../../interfaces/userroleinterface";
    import errormessagemanager from "../../../../managers/errormessagemanager";
    import {EventBus} from "../../../../eventbus";

    export default {
        name: 'AssignRoleToUserModal',

        data: () => ({
            roleSelected: false,
            changedUserRoles: [],

            error: false,
            errorMessage: null,

            currentUserHighestHierarchy: 0
        }),

        props: {
            value: Boolean,

            editMode: Boolean,
            user: {
                userId: Number,
                userName: String,
                firstName: String,
                lastName: String,
                email: String,
                isActive: Boolean
            },

            userRoles: Array
        },

        computed: {
            getTitle: function () {
                return this.editMode ? "Edit" : "";
            },

            onShow: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },

        created() {
            this.currentUserHighestHierarchy = this.$cookies.get('highestUserRoleHierarchy')
        },

        methods: {
            async onSaveSelectedRoles() {
                if (this.changedUserRoles != null && this.changedUserRoles.length > 0) {
                    for (const changedUserRole of this.changedUserRoles) {
                        let response = null;

                        if (changedUserRole.roleSelected) {
                            await userroleinterface.postUserRole(changedUserRole, res => {
                                response = res;
                            })
                        } else {
                            await userroleinterface.deleteUserRole(changedUserRole, res => {
                                response = res;
                            })
                        }

                        if (response != null && response.error) {
                            this.error = response.error;
                            errormessagemanager.getUpdateErrorMessage(response.status, message => {
                                this.errorMessage = message;
                            })
                        } else {
                            await this.close();
                        }
                    }
                } else {
                    await this.close();
                }
            },

            onRoleSelected(userRole) {
                let containedIndex = -1;

                this.changedUserRoles.forEach(changedUserRole => {
                    if (changedUserRole.role != null && userRole.role != null && changedUserRole.role.roleId === userRole.role.roleId) {
                        containedIndex = this.changedUserRoles.indexOf(userRole);
                    }
                });

                if (containedIndex !== -1) {
                    this.changedUserRoles.splice(containedIndex, 1);
                } else {
                    this.changedUserRoles.push(userRole);
                }
            },

            isRoleAssignmentDisabled(userRole) {
                if (!this.editMode || this.currentUserHighestHierarchy === 0) {
                    return true;
                }

                return userRole !== undefined && userRole.role !== undefined && userRole.role.hierarchy !== undefined
                    ? userRole.role.hierarchy < this.currentUserHighestHierarchy
                    : true;
            },

            async close() {
                await EventBus.$emit('userRoleAssignmentModalClosed');
                this.onShow = false;


                this.clearData();
                this.resetAlert();
            },

            resetAlert() {
                this.error = false;
                this.errorMessage = null;
            },

            clearData() {
                this.roleSelected = false;
                this.changedUserRoles = [];
            }
        }
    };


</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/common/users/modals/AssignRoleToUserModal.vue